<!--  
	The main screen for logged user
-->



<script>

	// imports
	// ------------------------------------------------------------------------
	import string from '../Data/translations.js';
	import appState from '../Data/state.svelte.js';
	import training from '../Data/training.js';
	import { appear, slide } from '../Helpers/transitions.js';
	import MainAction from '../UI/MainAction.svelte';
	import Sidebar from '../UI/Sidebar.svelte';


	// get the training data
	// ------------------------------------------------------------------------
	let comingUp = $derived(training[appState.level][appState.set]['pushups'].reduce((a, b) => a + b, 0));
	let sidebarData = $derived([appState.pushupsLast, comingUp, appState.set]);

</script>




<Sidebar data={sidebarData} />

<section class="main" out:slide|global={{ direction: 'out' }}>
	<div class="content">
		<ul class="content-info">
			<li in:appear|global class="content-info-value">{string.lastDay}</li>
			<li in:appear|global={{ delay: 200 }} class="content-info-value">{string.comingUp}</li>
			<li in:appear|global={{ delay: 400 }} class="content-info-value">{string.currentLevel}</li>
		</ul>
	</div>

	<MainAction delay={400} changePageTo="Training">{string.startNextTraining}</MainAction>
</section>